"use client"


import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";

import { connect } from "react-redux";
import dynamic from 'next/dynamic';

import { CSSTransition } from "react-transition-group";

import { AppTopbar } from "../AppTopbar";
import { AppFooter } from "../AppFooter";
import { AppMenu } from "../AppMenu";
import { AppConfig } from "../AppConfig";
import TabBarContainer from "../components/tabs/TabBar";

import { PlantillaService } from '../service/PlantillaService';

import PrimeReact from "primereact/api";
import { Tooltip } from "primereact/tooltip";
import { useTimout } from 'primereact/hooks';
import { useInterval } from 'primereact/hooks';

import { selectTab } from "../components/tabs/tabsActions";
import TemplateContent from "./TemplateContent";
import { Toast } from 'primereact/toast';

import ChartDemo from '../components/ChartDemo';
import HomeDemo from '../components/HomeDemo';

import AuthStorage  from '../storage/AuthStorage';
import { getConfigSubdomainDefault, GetCurrentUserDefault } from '../storage/getConfigSubdomainDefault';
import AuthController from '../controller/AuthController';


import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "../assets/demo/flags/flags.css";
import "../assets/demo/Demos.scss";
import "../assets/layout/layout.scss";
import "../App.scss";
//import { render } from "preact/compat";

import { verifySubdomainBase, verifyUser } from '../routes/ConfigSubdomain';

const TemplateGuest = (props) => {

    console.log("TemplateGuest.js");
    //verifyUser();

    const [layoutMode, setLayoutMode] = useState("static");
    const [layoutColorMode, setLayoutColorMode] = useState("light");
    const [inputStyle, setInputStyle] = useState("outlined");
    const [ripple, setRipple] = useState(true);
    const [staticMenuInactive, setStaticMenuInactive] = useState(false);
    const [overlayMenuActive, setOverlayMenuActive] = useState(false);
    const [mobileMenuActive, setMobileMenuActive] = useState(false);
    const [mobileTopbarMenuActive, setMobileTopbarMenuActive] = useState(false);
    const copyTooltipRef = useRef();


    const [comodin, setComodin] = useState(0);
    const [menu, setMenu] = useState([]);

    const tabs = useRef([]);
    const toast = useRef();

    const plantillaService = new PlantillaService();


    const authController = new AuthController();

    const [authStorage, setAuthStorage] = useState(undefined);

    const [dataConfigSubdomain, setDataConfigSubdomain] = useState(getConfigSubdomainDefault);
    let { subdomain, idSuscripcion, idEmpresaInit, idiomaInit } = dataConfigSubdomain;



    const userDetails = authStorage ? authStorage.GetCurrentUser() : GetCurrentUserDefault();
    let { userName, idEmpresa, idioma, sessionGUID, documentoInvitado } = userDetails;

    useEffect(() => {
    }, [comodin]);


    useEffect(() => {

        console.log("useEffect_loadTemplate");

        const authStorage = new AuthStorage(window.location.pathname);
        let mewdataConfigSubdomain = authStorage.getConfigSubdomain();

        setAuthStorage(authStorage);
        setDataConfigSubdomain(mewdataConfigSubdomain);

        const userDetails = authStorage.GetCurrentUser();
        userName = userDetails.userName;
        idioma = userDetails.idioma;
        idEmpresa = userDetails.idEmpresa;
        sessionGUID = userDetails.sessionGUID
        documentoInvitado = userDetails.documentoInvitado


        subdomain = mewdataConfigSubdomain.subdomain;
        idSuscripcion = mewdataConfigSubdomain.idSuscripcion;
        idEmpresaInit = mewdataConfigSubdomain.idEmpresaInit;
        idiomaInit = mewdataConfigSubdomain.idiomaInit;


        if (1 == 0 && userName === undefined) {

            const formVisit = {
                idSuscripcion: idSuscripcion,
                idioma: idiomaInit,
                idEmpresa: idEmpresaInit,
                subdomain: subdomain,
                userName: 'visit',
                password: ''
            };

            let response = authController.loginUser(formVisit) //loginUser action makes the request and handles all the neccessary state changes
            console.log("responseVisit, ", response);

            const userDetails = authStorage.GetCurrentUser();
            userName = userDetails.userName;
            idEmpresa = userDetails.idEmpresa;
            idioma = userDetails.idioma;
            sessionGUID = userDetails.sessionGUID;
            documentoInvitado = userDetails.documentoInvitado;

        }

        if (userName !== undefined && userName !== "visit") {
            plantillaService.getMenuItems(idEmpresa, idioma, userName, documentoInvitado).then(data => {

                const tabInit = { name: "initHome", label: "home", codMenu: "BASF001", component: HomeDemo }
                tabs.current = [tabInit];

                let menuProcesos = [];
                let menuItemsData = [];
                let dataItem = null;
                let newMenuI = null;

                for (const i in data) {

                    dataItem = data[i];
                    if (dataItem.tg === "SYS_BAS_PROCESO_MENU") {
                        let newMenuProceso = {
                            tg: dataItem.tg,
                            orden: dataItem.orden,
                            codMenu: dataItem.codMenu,
                            label: dataItem.ctiTexto,
                            icon: "pi pi-fw pi-user-edit",
                            items: [],
                        };

                        menuProcesos.push(newMenuProceso);
                    }
                    else {
                        newMenuI = { tg: dataItem.tg, parentMenu: dataItem.parentMenu, orden: dataItem.orden, codMenu: dataItem.codMenu, name: dataItem.codMenu, label: `${dataItem.ctiTexto}`, icon: "pi pi-fw pi-user-edit", command: (e) => { addTabMenu(e) } };
                        menuItemsData.push(newMenuI);
                    }

                }


                // falta ordenar
                menuProcesos.forEach((item, index, arr) => {
                    item.items = menuItemsData.filter(m => m.parentMenu === item.codMenu);
                });

                let newMenuItems = [];
                newMenuItems.push(newMenuI);

                setTimeout(() => {
                    setMenu(menuProcesos);
                }, 1);

            });
        }

    }, []);


    const addTabMenu = (event) => {

        let newTabs = [...tabs.current];

        setTimeout(() => {

            let _tab = newTabs.find(x => x.codMenu === event.item.codMenu);

            let _maximoTabs = 7;

            if (_tab !== undefined) {

                //setMenu(newMenu);

                let index = newTabs.indexOf(_tab)
                if (index > -1) {
                    newTabs.splice(index, 1);
                    newTabs.splice(1, 0, _tab);
                    tabs.current = newTabs;
                }

                let actionTab = selectTab(event.item.codMenu);
                props.dispatch(actionTab);

                setComodin((prev) => prev + 1);

            }
            else {

                if (newTabs.length <= _maximoTabs) {

                    newTabs.push({ name: event.item.name, codMenu: event.item.codMenu, label: event.item.label, component: TemplateContent });

                    tabs.current = newTabs;
                    let actionTab = selectTab(event.item.name);
                    props.dispatch(actionTab);
                    setComodin((prev) => prev + 1);


                }
                else {
                    showMensaje(`Excede el máximo de ${_maximoTabs} pestañas`);
                }

            }

        }, 1);

    }

    const onClickTabSecundary = (e) => {
        console.log("hola");
    }

    const onAfterDeleteTab = (name) => {
        let newTabs = [...tabs.current];

        setTimeout(() => {

            let _tabInit = newTabs[0];
            let _tab = newTabs.find(x => x.name === name);
            let index = newTabs.indexOf(_tab)
            if (index > -1) {
                newTabs.splice(index, 1);
            }

            tabs.current = newTabs;

            let actionTab = selectTab(_tabInit.name);
            props.dispatch(actionTab);

            setComodin((prev) => prev + 1);

        }, 1);
    }

    const onSelectedFromMenu = (name) => {

        let newTabs = [...tabs.current];

        setTimeout(() => {

            let _tabInit = newTabs[0];
            let _tab = newTabs.find(x => x.name === name);
            let index = newTabs.indexOf(_tab)
            if (index > -1) {
                newTabs.splice(index, 1);
                newTabs.splice(1, 0, _tab);

                tabs.current = newTabs;
            }

            let actionTab = selectTab(name);
            props.dispatch(actionTab);

            setComodin((prev) => prev + 1);

        }, 1);
    }

    const showMensaje = (mensaje) => {
        toast.current.show({ severity: 'info', summary: mensaje, life: 2000 });
    }

    PrimeReact.ripple = true;

    let menuClick = false;
    let mobileTopbarMenuClick = false;



    useEffect(() => {
        if (mobileMenuActive) {
            addClass(document.body, "body-overflow-hidden");
        } else {
            removeClass(document.body, "body-overflow-hidden");
        }
    }, [mobileMenuActive]);

    //useEffect(() => {
    //    copyTooltipRef && copyTooltipRef.current && copyTooltipRef.current.updateTargetEvents();
    //}, [location]);

    const onInputStyleChange = (inputStyle) => {
        setInputStyle(inputStyle);
    };

    const onRipple = (e) => {
        PrimeReact.ripple = e.value;
        setRipple(e.value);
    };

    const onLayoutModeChange = (mode) => {
        setLayoutMode(mode);
    };

    const onColorModeChange = (mode) => {
        setLayoutColorMode(mode);
    };

    const onWrapperClick = (event) => {
        if (!menuClick) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }

        if (!mobileTopbarMenuClick) {
            setMobileTopbarMenuActive(false);
        }

        mobileTopbarMenuClick = false;
        menuClick = false;
    };

    const onToggleMenuClick = (event) => {
        menuClick = true;

        if (isDesktop()) {
            if (layoutMode === "overlay") {
                if (mobileMenuActive === true) {
                    setOverlayMenuActive(true);
                }

                setOverlayMenuActive((prevState) => !prevState);
                setMobileMenuActive(false);
            } else if (layoutMode === "static") {
                setStaticMenuInactive((prevState) => !prevState);
            }
        } else {
            setMobileMenuActive((prevState) => !prevState);
        }

        event.preventDefault();
    };

    const onSidebarClick = () => {
        menuClick = true;
    };

    const onMobileTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        setMobileTopbarMenuActive((prevState) => !prevState);
        event.preventDefault();
    };

    const onMobileSubTopbarMenuClick = (event) => {
        mobileTopbarMenuClick = true;

        event.preventDefault();
    };

    const onMenuItemClick = (event) => {
        if (!event.item.items) {
            setOverlayMenuActive(false);
            setMobileMenuActive(false);
        }
    };
    const isDesktop = () => {
        return window.innerWidth >= 992;
    };

    const addClass = (element, className) => {
        if (element.classList) element.classList.add(className);
        else element.className += " " + className;
    };

    const removeClass = (element, className) => {
        if (element.classList) element.classList.remove(className);
        else element.className = element.className.replace(new RegExp("(^|\\b)" + className.split(" ").join("|") + "(\\b|$)", "gi"), " ");
    };

    const wrapperClass = classNames("layout-wrapper", {
        "layout-overlay": layoutMode === "overlay",
        "layout-static": layoutMode === "static",
        "layout-static-sidebar-inactive": staticMenuInactive && layoutMode === "static",
        "layout-overlay-sidebar-active": overlayMenuActive && layoutMode === "overlay",
        "layout-mobile-sidebar-active": mobileMenuActive,
        "p-input-filled": inputStyle === "filled",
        "p-ripple-disabled": ripple === false,
        "layout-theme-light": layoutColorMode === "light",
    });

    //authController.configSubdomain

    /* 
             
    */

    if (typeof window !== undefined && (userName !== "" && (userName.includes('/guest') || userName.includes('/visit')))) {

        console.log("entró A");
        verifySubdomainBase();


        return (

             <div className={wrapperClass} onClick={onWrapperClick}>
                <Toast ref={toast} />
                <Tooltip ref={copyTooltipRef} target=".block-action-copy" position="bottom" content="Copied to clipboard" event="focus" />

                <AppTopbar onToggleMenuClick={onToggleMenuClick} layoutColorMode={layoutColorMode} mobileTopbarMenuActive={mobileTopbarMenuActive} onMobileTopbarMenuClick={onMobileTopbarMenuClick} onMobileSubTopbarMenuClick={onMobileSubTopbarMenuClick} />


                <div className="layout-sidebar" onClick={onSidebarClick}>
                    <AppMenu model={menu} onMenuItemClick={onMenuItemClick} layoutColorMode={layoutColorMode} />
                </div>

                <div className="layout-main-container">
                    <div className="App">

                        <TabBarContainer tabs={tabs.current} listenerParent={onClickTabSecundary} onAfterDeleteTab={onAfterDeleteTab} onSelectedFromMenu={onSelectedFromMenu} isDesktop={isDesktop()} isMenuActive={mobileMenuActive || (mobileMenuActive && !staticMenuInactive && layoutMode === "static") || (!mobileMenuActive && !staticMenuInactive && layoutMode === "static") || (overlayMenuActive && layoutMode === "overlay")} size="massive" />

                        <AppFooter layoutColorMode={layoutColorMode} />
                    </div>
                </div>

                <AppConfig rippleEffect={ripple} onRippleEffect={onRipple} inputStyle={inputStyle} onInputStyleChange={onInputStyleChange} layoutMode={layoutMode} onLayoutModeChange={onLayoutModeChange} layoutColorMode={layoutColorMode} onColorModeChange={onColorModeChange} />

                <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                    <div className="layout-mask p-component-overlay"></div>
                </CSSTransition>

            </div>

        );

    }
    else {

        console.log("entró B");
        //if (userName === 'visit') {
        return (
            <div className={wrapperClass} onClick={onWrapperClick}>

                <div className="layout-main">{props.children}</div>

                <CSSTransition classNames="layout-mask" timeout={{ enter: 200, exit: 200 }} in={mobileMenuActive} unmountOnExit>
                    <div className="layout-mask p-component-overlay"></div>
                </CSSTransition>
            </div>
        );
    }

};

//export default connect(null)(TemplateGuest);
export default dynamic(() => Promise.resolve(connect(null)(TemplateGuest)), {ssr: false});